import React from "react";
import Nav from "react-bootstrap/Nav";

import { AiFillGithub, AiOutlineWhatsApp, AiOutlineMail } from "react-icons/ai";

import { BsTelegram, BsPersonVcard } from "react-icons/bs";

const socials = [
  {
    id: 1,
    icon: <BsTelegram className='react-icons' />,
    url: "https://t.me/AndreyBond/",
    ariaLabel: "Telegram",
    active: true,
  },
  {
    id: 2,
    icon: <AiOutlineWhatsApp className='react-icons' />,
    url: "https://wa.me/79169450587",
    ariaLabel: "WhatsApp",
    active: true,
  },
  {
    id: 3,
    icon: <AiOutlineMail className='react-icons' />,
    url: "mailto:001-001@staminaweb.ru",
    ariaLabel: "Email",
    active: true,
  },
  {
    id: 4,
    icon: <AiFillGithub className='react-icons' />,
    url: "https://github.com/andreybond79/",
    ariaLabel: "GitHub",
    active: true,
  },
  {
    id: 5,
    icon: <BsPersonVcard className='react-icons' />,
    url: "https://profi.ru/profile/BondarenkoAA146",
    ariaLabel: "Profi",
    active: true,
  },
];

const SocialButtons = () => {
  return (
    <Nav className='flex-row'>
      {socials.map((social) => {
        const { id, icon, url, ariaLabel, active } = social;
        return (
          active && (
            <Nav.Link
              key={id}
              href={url}
              aria-label={ariaLabel}
              target='_blank'
              rel='noopener noreferrer'
            >
              {icon}
            </Nav.Link>
          )
        );
      })}
    </Nav>
  );
};

export default SocialButtons;
